<div class="widgetcontainer">
  @if (isVaglager) {
    <div class="widget"><i class="fas fa-road"></i></div>
  }
  @if (count > 0) {
    <div class="widget">
      <div class="badge space">
        <i class="fal fa-map space"></i>{{ count | number: '1.0-0' }}
      </div>
      @if (volume > 0) {
        <div class="line">
          <b>{{ volume | number: '1.0-0' }}</b>&nbsp;<small>m3f</small>
        </div>
      }
    </div>
  }
  @if (selectedcount > 0) {
    <div class="widget">
      <div class="badge space">
        <i class="fal fa-lasso space"></i>{{ selectedcount | number: '1.0-0' }}
      </div>
      @if (selectedvolume > 0) {
        <div class="line">
          <b>{{ selectedvolume | number: '1.0-0' }}</b>&nbsp;<small>m3f</small>
        </div>
      }
    </div>
  }
</div>
